import React from 'react';
import PropTypes from 'prop-types';
import LinkModel from 'components/Models/Link/Link';
import Icon from "components/Icon";
import cn from 'classnames';
import './InvestorLink.scss';

const InvestorLink = ({
    className,
    openInNewWindow = false,
    url,
    linkText,
    tabindex,
    iconName,
    leftIconName,
    download,
    onFocus = () => {},
    onBlur = () => {},
    onClick = () => {}
}) => (
    <a
        href={url}
        className={cn('investor-link', {
            [className]: className,
        })}
        target={openInNewWindow ? '_blank' : null}
        rel={openInNewWindow ? 'nofollow noopener noreferrer' : null}
        tabIndex={tabindex}
        download={download}
        onFocus={onFocus}
        onBlur={onBlur}
        onClick={onClick}
    >
        {leftIconName && (<Icon icon={leftIconName} className="investor-link__icon investor-link__icon_left" />)}
        {linkText && (<span className="investor-link__text">{linkText}</span>)}
        {iconName && (<Icon icon={iconName} className="investor-link__icon" />)}
    </a>
);

InvestorLink.propTypes = Object.assign({}, LinkModel.propTypes, {
    download: PropTypes.bool,
    className: PropTypes.string, // FE only
    tabindex: PropTypes.number, // FE only
    onFocus: PropTypes.func, // FE only
    onBlur: PropTypes.func, // FE only
    onClick: PropTypes.func, // FE only
});

export default InvestorLink;



// WEBPACK FOOTER //
// ./src/components/InvestorLink/InvestorLink.jsx